@if (show) {
  <a
    class="text-decoration-none"
    [class]="params.className"
    [class.disabled]="isDisabled"
    [attr.aria-disabled]="isDisabled"
    (click)="onClick()"
  >
    <i class="fa-lg" [class]="iconClass"></i>
    @if (buttonText) {
      <span class="fw-bold">&nbsp;{{ buttonText }}</span>
    }
  </a>
}
